import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d84abe66&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=d84abe66&prod&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&id=d84abe66&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84abe66",
  null
  
)

export default component.exports